
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import LessonsData from "@/components/lessonsData/lessons-data.vue";
import {IconEnum, SizeEnum} from "@/ts/Enum";
import Materials from "@/ts/Materials";
import ClassRoomService from "@/services/classRoom.service";

@Component({
  components: {LessonsData}
})
export default class LessonsDataDialog extends Vue {
  /**
   * 园区ID
   */
  @Prop() gardenId: string
  /**
   * 课节ID
   */
  @Prop() lessonId: string
  /**
   * 授课时间
   */
  @Prop() teachDate: string

  // 是否展示备课资料弹框
  showLessonDataDialogFlag = false
  // 备课资料列表
  materials =[]
  lessonsSize = SizeEnum.small.toString()

  get buttonDisableFlag() {
    return !this.lessonId || !this.teachDate || !this.gardenId
  }

  @Watch("lessonId", {deep: true, immediate: false})
  isSendWatch() {
    if (this.lessonId) {
      this.getMaterial(this.lessonId, this.teachDate)
    }
  }

  created(): void {
    // 获取备课资料
    if (this.lessonId && this.teachDate) {
      this.getMaterial(this.lessonId, this.teachDate)
    }
  }

  mounted(): void {
  }

  /**
   * 获取课节资料
   */
  getMaterial(lessonId, date) {
    ClassRoomService.getMaterial({
      lessonId: lessonId,
      date: date,
      lessonStage: "1",
      courseMaterialDesign: null,
    }).then((res) => {
      if (res) {
        let list = []
        res.forEach((e) => {
          let materials1 = new Materials(
              e.id,
              e.name,
              e.path,
              e.size,
              e.courseMaterialId,
              e.courseMaterialDesign,
              e.courseMaterialDesignName,
              e.designSort,
              e.isMain,
              e.lessonStage,
              e.fontTone,
              e.backgroudTone,
              e.lastUpdatorId,
              e.lastUpdateTime
          );
          if (materials1.icon == IconEnum.video) {
          } else {
            materials1.path = this.filePre$.downloadUrl + materials1.path;
          }
          list.push(materials1)
        });

        this.materials = list;
      } else {
        this.materials = [];
      }
    }).catch(() => {
      this.materials = [];
    });
  }

  /**
   * 展示课节资料弹框
   */
  showLessonDataDialog() {
    this.showLessonDataDialogFlag = true
  }

  /**
   * 关闭课节资料弹框
   */
  closeLessonDataDialog() {
    this.showLessonDataDialogFlag = false
  }


}
